import { ViewportRuler } from '@angular/cdk/scrolling';
import { DestroyRef, DOCUMENT, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PlatformService } from '@rma/generic/util/environment';
import { filter, map, startWith } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ViewportHeightService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly platformService = inject(PlatformService);
  private readonly viewportRuler = inject(ViewportRuler);

  public readonly viewportHeight$ = this.viewportRuler.change(300).pipe(
    startWith(true),
    filter(() => this.platformService.isPlatformBrowser),
    map(() => this.viewportRuler.getViewportSize().height),
  );

  public initialise(): void {
    this.viewportHeight$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((height) => {
      this.document.documentElement.style.setProperty('--vh', `${height}px`);
    });
  }
}
